import { AxiosError, AxiosResponse } from 'axios';
import { Observable, catchError, from, map, tap } from 'rxjs';


import APIAxios, { APIRoutes } from '@api/axios.api';
import SnackError from '@utils/error.utils';
import { AuditDetails } from './audits-details.model';
import { getAuditDetailsDataSource } from './audits-details.requests';
import { auditDetailsStore } from './audits-details.store';

export class AuditDetailsService {
  store = auditDetailsStore;

  resetStore = () => this.store.reset();
  resetDocuments = () => this.store.update((state) => ({
    ...state,
    documents: [],
  }));

  getAuditById = (audit: number | string): Observable<AuditDetails> => {
    return from(APIAxios(APIRoutes.GETAuditById(audit)))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: AxiosResponse<AuditDetails>) => {
          return response.data;
        }),
        tap((audit) =>
          this.store.update((state) => ({
            ...state,
            ...audit,
          }),
            getAuditDetailsDataSource.setSuccess(),
          )
        ),
        getAuditDetailsDataSource.trackRequestStatus(),
      );
  };
}

export const auditDetailsService = new AuditDetailsService();
